import { render, staticRenderFns } from "./AccountPage.vue?vue&type=template&id=35471bf4&scoped=true"
import script from "./AccountPage.vue?vue&type=script&lang=ts"
export * from "./AccountPage.vue?vue&type=script&lang=ts"
import style0 from "./AccountPage.vue?vue&type=style&index=0&id=35471bf4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35471bf4",
  null
  
)

export default component.exports